import React, { useEffect, useState, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../services/api";
import ToastContext from "../contexts/ToastContext";
import "./Auth.css";

function VerificarEmail() {
  const { token } = useParams();
  const [status, setStatus] = useState("verificando");
  const { addToast } = useContext(ToastContext);

  useEffect(() => {
    const verificarToken = async () => {
      try {
        await api.get(`/auth/verify-email/${token}`);
        setStatus("sucesso");
        addToast("Email verificado com sucesso!", "success");
      } catch (error) {
        setStatus("erro");
        addToast(
          error.response?.data?.message || "Erro ao verificar email.",
          "error"
        );
      }
    };
    verificarToken();
  }, [token, addToast]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        {status === "verificando" && <h1>Verificando seu email...</h1>}
        {status === "sucesso" && (
          <>
            <h1>Email Verificado com Sucesso!</h1>
            <p>Sua conta foi ativada. Agora você pode fazer o login.</p>
            <Link to="/login" className="btn-modern">
              Ir para o Login
            </Link>
          </>
        )}
        {status === "erro" && (
          <>
            <h1>Ocorreu um Erro</h1>
            <p>
              O link de verificação é inválido ou expirou. Por favor, tente se
              cadastrar novamente.
            </p>
            <Link to="/cadastro" className="btn-modern">
              Ir para o Cadastro
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default VerificarEmail;
